module.exports = __webpack_public_path__ + "img/image12.acc8d336.png";